module.exports = __webpack_public_path__ + "static/media/body-rigth.955ea1be.png";